import { HeaderMenu } from "components"
import { useParams, useSearchParams } from "react-router-dom"
import { TabProfile } from "./TabProfile"
import { TabNavTransaction } from "../components/TabNavTransaction"
import { TabTransactionPath } from "../types"
import { useState } from "react"
import { TabBoq } from "./TabBoq"
import { TabTransaction } from "./TabTransaction"
// import { useState } from "react"

type TabsSearchParams = {
    tabs: TabTransactionPath
}

type ViewProjectProps = {
    id?: string;
  };


export default function ViewProject(props:ViewProjectProps): JSX.Element {
    const { id:paramId } = useParams<{ id: string }>()
    const id = props.id ?? paramId;
    const [searchParams, setSearchParams] = useSearchParams({ tabs: "profile" } as TabsSearchParams)
    const activeTab = searchParams.get("tabs")
    const [projectCode, setProjectCode] = useState('')
    const setActiveTab = (path: string) => setSearchParams({ tabs: path })
    let disablePath = [""]

    return (
        <section className="container my-5">
            <HeaderMenu title="PROJECT"  action={'view'} className="sticky top-[0px] z-[1]" >
                <div>{projectCode}</div>
            </HeaderMenu>
            <TabNavTransaction activeTab={activeTab!} setActiveTab={setActiveTab} disablePath={disablePath}/>
            {activeTab === "profile" && <TabProfile setProjectCode={setProjectCode} action={'view'} project_id={String(id!)} approval_view={Boolean(props.id ?? false)}/>}
            {activeTab === "boq" && <TabBoq action={'view'} project_id={String(id!)}/>}
            {activeTab === "transaction" && <TabTransaction  action={'view'} project_id={String(id!)} />}
        </section>
    )
}